__turbopack_context__.v({
  "boxed": "PersonCard-module__ZLErMW__boxed",
  "card": "PersonCard-module__ZLErMW__card",
  "detail": "PersonCard-module__ZLErMW__detail",
});
